import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumStandardOrder implements BaseEnumType {
  private static allValues: EnumStandardOrder[] = []; // make sure this is top-most
  
  public static fullPriceDutyPaid = new EnumStandardOrder(0, "FullPriceDutyPaid", "enum_standard_order_full_price_duty_paid");
  public static priceExcludingDutyDutySuspended = new EnumStandardOrder(1, "PriceExcludingDutyDutySuspended", "enum_standard_order_price_excluding_duty_duty_suspended");
  public static fullPriceDutyPaidElsewhere = new EnumStandardOrder(2, "FullPriceDutyPaidElsewhere", "enum_standard_order_full_price_duty_paid_elsewhere");
  public static exportDutySuspended = new EnumStandardOrder(3, "ExportDutySuspended", "enum_standard_order_export_duty_suspended");
  public static consumeOnPremisesNoDuty = new EnumStandardOrder(4, "ConsumeOnPremisesNoDuty", "enum_standard_order_consume_on_premises_no_duty");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumStandardOrder.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isFullPriceDutyPaid() { return this === EnumStandardOrder.fullPriceDutyPaid; }
  public isPriceExcludingDutyDutySuspended() { return this === EnumStandardOrder.priceExcludingDutyDutySuspended; }
  public isFullPriceDutyPaidElsewhere() { return this === EnumStandardOrder.fullPriceDutyPaidElsewhere; }
  public isExportDutySuspended() { return this === EnumStandardOrder.exportDutySuspended; }
  public isConsumeOnPremisesNoDuty() { return this === EnumStandardOrder.consumeOnPremisesNoDuty; }

  public static getValues(): readonly EnumStandardOrder[] {
    return EnumStandardOrder.allValues;
  }

  public static getValuesExcept0(): readonly EnumStandardOrder[] {
    return EnumStandardOrder.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumStandardOrder {
    const found = EnumStandardOrder.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumStandardOrder - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumStandardOrder): EnumStandardOrder {
    const found = name ? EnumStandardOrder.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumStandardOrder - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumStandardOrder>): boolean {
    return this.key === other?.key;
  }
}